import { Button, Form, Modal } from "react-bootstrap";
import netflixLogo from "../../Common/_assets/img/logo/netflix-logo-ribbon.png";
import { useState, useRef, useEffect } from "react";
import { indeeAuth } from "../../utils/api/helpers/indee";
import iconAppletv from "../../Common/_assets/img/icon/icon-appletv.png";
import iconIos from "../../Common/_assets/img/icon/icon-ios.png";
import iconRoku from "../../Common/_assets/img/icon/icon-roku.png";
import iconAmazonfire from "../../Common/_assets/img/icon/icon-amazonfire.png";

const LoginModal = ({
	displayPinModal,
	setDisplayPinModal,
	setDisplayScreenerProjectList,
	projectKey,
	authActionFlag,
	setAuthActionFlag,
	authComplete,
	setAuthComplete,
	success,
	setSuccess,
}) => {
	const [pin, setPin] = useState("");

	const inputRef = useRef();

	useEffect(() => {
		clearForm();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	const clearForm = () => {
		setPin("");
		setSuccess(false);
		setAuthComplete(false);
		setAuthActionFlag(false);
		if (inputRef.current) {
			inputRef.current.value = "";
		}
	};

	const authorize = () => {
		indeeAuth(pin).then((result) => {
			let successful = !(
				(result.data.error && result.data.message.unauth) ||
				result.data.status_code === "W2002"
			);
			setSuccess(successful);
			setAuthComplete(true);
			setAuthActionFlag(!authActionFlag);
			if (successful) {
				setDisplayScreenerProjectList(true);
				setDisplayPinModal(false);
			}
		});
	};

	return (
		<Modal
			centered
			show={displayPinModal}
			onHide={() => {
				clearForm();
				setDisplayPinModal(false);
			}}
		>
			<Modal.Header closeButton>
				<Modal.Title></Modal.Title>
			</Modal.Header>

			<Modal.Body className={"text-center"}>
				<div className={"my-4 pb-2"}>
					<div
						className={
							"d-flex align-items-center justify-content-center"
						}
					>
						<div
							className={
								"d-flex align-items-center justify-content-center pe-3"
							}
						>
							<img
								src={netflixLogo}
								className="header__logo"
								alt="Netflix"
								style={{ maxWidth: "15px" }}
							/>
						</div>
						<div
							className={
								"d-flex align-items-center justify-content-center"
							}
						>
							<span
								className={""}
								style={{
									fontSize: "14px",
									fontWeight: "300",
									color: "#aaa",
								}}
							>
								FYC
							</span>
						</div>
					</div>
				</div>
				<div className={"h4 text-white"}>
					{!authComplete
						? "Enter Your Screener Code"
						: success
							? "Success!"
							: "Unauthorized"}
				</div>
				<div className={"p mb-4 pb-2"}>
					{!authComplete
						? "Enter the code you received to access your FYC Screener Content."
						: success
							? "Click below to continue. You may access screeners at any time by clicking\n" +
								'                                    "Watch Now" on any title page.'
							: "There was an issue with the code you entered. Please try again."}
				</div>

				{!authComplete && !success ? (
					<Form.Group controlId={"IndeePin"} className={"pin-input"}>
						<Form.Control
							value={pin}
							ref={inputRef}
							onChange={(e) => setPin(e.target.value)}
							placeholder={"Code"}
						/>
					</Form.Group>
				) : null}
			</Modal.Body>

			<Modal.Footer className={"flex-column"}>
				<div className={"d-flex justify-content-center"}>
					{!authComplete && !success ? (
						<Button variant="primary" onClick={() => authorize()}>
							{"SUBMIT"}
						</Button>
					) : null}
					{authComplete && !success ? (
						<Button
							variant="primary"
							onClick={() => {
								setAuthComplete(false);
								setPin("");
							}}
						>
							{"ENTER NEW CODE"}
						</Button>
					) : null}
					{authComplete && success && !projectKey ? (
						<Button
							onClick={() => {
								setDisplayPinModal(false);
								setDisplayScreenerProjectList(true);
							}}
						>
							Watch Now
						</Button>
					) : null}
				</div>
				<div
					className={
						"d-flex justify-content-center text-uppercase text-white mt-5 mb-3"
					}
					style={{
						fontSize: ".75rem",
						letterSpacing: ".15em",
						opacity: 0.65,
					}}
				>
					Other Ways to Watch
				</div>
				<div
					className={
						"d-flex justify-content-center ways-to-watch-container"
					}
					style={{ gap: "1rem" }}
				>
					<div className={""}>
						<a
							href={
								"https://apps.apple.com/us/app/netflix-awards/id6469587713?platform=appleTV"
							}
							target={"_blank"}
							rel={"noopener noreferrer"}
						>
							<img
								src={iconAppletv}
								alt={"Apple TV"}
								style={{ width: 30 }}
							/>
						</a>
					</div>
					<div className={""}>
						<a
							href={
								"https://apps.apple.com/us/app/netflix-film-awards/id6469587713"
							}
							target={"_blank"}
							rel={"noopener noreferrer"}
						>
							<img
								src={iconIos}
								alt={"IOS"}
								style={{ width: 30 }}
							/>
						</a>
					</div>
					<div className={""}>
						<a
							href={
								"https://channelstore.roku.com/details/58fb9712c1dc2e92346f02e77ab90ea0/netflix-film-awards"
							}
							target={"_blank"}
							rel={"noopener noreferrer"}
						>
							<img
								src={iconRoku}
								alt={"Roku"}
								style={{ width: 40 }}
							/>
						</a>
					</div>
					<div className={""}>
						<a
							href={
								"https://www.amazon.com/gp/product/B0CL9FW826"
							}
							target={"_blank"}
							rel={"noopener noreferrer"}
						>
							<img
								src={iconAmazonfire}
								alt={"Amazon Fire"}
								style={{ width: 54 }}
							/>
						</a>
					</div>
				</div>
			</Modal.Footer>
		</Modal>
	);
};

export default LoginModal;
